<template lang="pug">
#filtro-monitoramento
    el-collapse(style='border: none; margin-top: 5px', value='filtros')
        el-collapse-item(name='filtros')
            span.titulo(slot='title', style='font-size: 16px')
                span.el-icon-s-data.m-2
                | Filtros

            el-form.fields(label-position='top', size='mini')
                el-form-item.tipo-monitoramento
                    label Tipo Monitoramento
                    el-select(v-model='filtros.tipoMonitoramento', clearable)
                        el-option(
                            v-for='option in tipoMonitoramento',
                            :key='option',
                            :label='option === "AGRICOLA_E_SOCIOAMBIENTAL" ? "Agrícola e Socioambiental" : option === "AGRICOLA" ? "Agrícola" : "Socioambiental"',
                            :value='option'
                        )
                            | {{ option === 'AGRICOLA_E_SOCIOAMBIENTAL' ? 'Agrícola e Socioambiental' : option === 'AGRICOLA' ? 'Agrícola' : 'Socioambiental' }}

                el-form-item.status
                    label Status
                    el-select(v-model='filtros.status', clearable)
                        el-option(
                            v-for='option in status',
                            :key='option',
                            :label='option === "ATIVO" ? "Ativo" : option === "FINALIZADO" ? "Finalizado" : "Cancelado"',
                            :value='option'
                        )
                            | {{ option === 'ATIVO' ? 'Ativo' : option === 'FINALIZADO' ? 'Finalizado' : 'Cancelado' }}

                el-form-item.situacao-colheita
                    label Situação Colheita
                    el-select(v-model='filtros.situacaoColheita', clearable)
                        el-option(
                            v-for='option in situacaoColheita',
                            :key='option',
                            :label='option === "NAO_COLHIDO" ? "Não colhido" : option === "EM_COLHEITA" ? "Em colheita" : "Colhido"',
                            :value='option'
                        )
                            | {{ option === 'NAO_COLHIDO' ? 'Não colhido' : option === 'EM_COLHEITA' ? 'Em colheita' : 'Colhido' }}

                el-form-item.ciclo
                    label Ciclo/ano
                    el-select(v-model='filtros.cicloAno', clearable)
                        el-option(
                            v-for='option in cicloAno',
                            :key='option',
                            :value='option'
                        )
                            | {{ option }}

                el-form-item.municipio-uf
                    label Município/UF
                    el-select(v-model='filtros.municipioUf', clearable)
                        el-option(
                            v-for='option in municipioUf',
                            :key='option',
                            :value='option'
                        )
                            | {{ option }}

                el-form-item.data-solicitacao
                    label Data solicitação
                    .date
                        el-date-picker(
                            v-model='filtros.dataSolicitacaoInicio',
                            type='date',
                            placeholder='Selecione',
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )
                        span à
                        el-date-picker(
                            v-model='filtros.dataSolicitacaoFim',
                            type='date',
                            placeholder='Selecione',
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )

                el-form-item.possui-alerta
                    label Possui alerta <br>
                        el-radio(v-model='filtros.possuiAlertas', label='SIM') Sim
                        el-radio.space-radio(
                            v-model='filtros.possuiAlertas',
                            label='NAO'
                        ) Não

                el-form-item.actions
                    .buttons
                        BaseButton(
                            type='outline',
                            icon='el-icon-delete',
                            @click='limparFiltros'
                        ) Limpar
                        BaseButton(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='filtrar'
                        ) Filtrar
</template>

<script>
import AreasMonitoradasService from '../services/AreasMonitoradasService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'Filtros',

    components: {
        BaseButton
    },

    emits: ['getFiltros'],

    data() {
        return {
            tipoMonitoramento: [],
            status: [],
            situacaoColheita: [],
            cicloAno: [],
            municipioUf: [],

            filtros: {
                tipoMonitoramento: null,
                status: null,
                situacaoColheita: null,
                cicloAno: null,
                municipioUf: null,
                dataSolicitacaoInicio: null,
                dataSolicitacaoFim: null,
                possuiAlertas: null
            }
        };
    },

    created() {
        this.findFiltros();
    },

    methods: {
        findFiltros() {
            AreasMonitoradasService.findFiltros().then(({ data }) => {
                this.tipoMonitoramento = data.tipoMonitoramento.sort();
                this.cicloAno = data.cicloAno.sort();
                this.municipioUf = data.municipioUf.sort();
                this.status = data.status.sort();
                this.situacaoColheita = data.situacaoColheita.sort();
            });
        },

        limparFiltros() {
            this.filtros = {
                tipoMonitoramento: null,
                status: null,
                situacaoColheita: null,
                cicloAno: null,
                municipioUf: null,
                dataSolicitacaoInicio: null,
                dataSolicitacaoFim: null,
                possuiAlertas: null
            };
            this.$emit('getFiltros', this.filtros);
        },

        filtrar() {
            this.$emit('getFiltros', this.filtros);
        }
    }
};
</script>

<style scoped lang="scss">
#filtro-monitoramento {
    background-color: var(--white);
    width: 100%;
    padding: 0 15px;

    overflow: hidden;
    border-radius: 4px;

    .fields {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-areas:
            'tipo-monitoramento tipo-monitoramento status status situacao-colheita situacao-colheita ciclo ciclo'
            'municipio-uf municipio-uf data-solicitacao data-solicitacao data-solicitacao possui-alerta acoes acoes';
        column-gap: 15px;

        .tipo-monitoramento {
            grid-area: tipo-monitoramento;
        }
        .status {
            grid-area: status;
        }
        .situacao-colheita {
            grid-area: situacao-colheita;
        }
        .ciclo {
            grid-area: ciclo;
        }
        .municipio-uf {
            grid-area: municipio-uf;
        }
        .data-solicitacao {
            grid-area: data-solicitacao;
        }
        .possui-alerta {
            grid-area: possui-alerta;
        }
        .actions {
            grid-area: acoes;
        }
    }

    label {
        margin-bottom: -5px;
    }

    .el-select {
        margin-top: -20px;
        width: 100%;
    }

    .el-date-picker {
        width: 40%;
    }

    .titulo {
        font-size: 14px;
        font-family: 'Roboto', 'sans serif';
    }

    .date {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .actions {
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .buttons {
            display: flex;
            justify-content: flex-end;
            margin-top: 15px;
        }
    }

    .el-icon-arrow-right:before {
        margin-left: 0;
    }
    .space-radio {
        padding-left: 8px;
    }
}
</style>
